import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Bell, Lock, AlertTriangle } from "lucide-react";

export function OperacoesNotificacoesSection({
  reportEmail, setReportEmail,
  whatsappNumber, setWhatsappNumber,
  autoClose, setAutoClose,
  autoCloseHora, setAutoCloseHora,
  isMidnightHour,
}) {
  return (
    <>
      {/* Notificações de fecho de caixa */}
      <div className="bg-white border rounded-xl p-5 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0 mt-0.5">
            <Bell className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <p className="font-semibold text-sm">Notificações de fecho de caixa</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Recebe um resumo por email e WhatsApp sempre que o caixa for fechado (manual ou automático).
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-700 block mb-1.5">
              Email para relatório de fecho
            </label>
            <Input
              type="email"
              placeholder="gerente@restaurante.com"
              value={reportEmail}
              onChange={e => setReportEmail(e.target.value)}
              data-testid="auto-close-email"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Recebe o relatório detalhado com totais por método de pagamento.
            </p>
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-700 block mb-1.5">
              Número WhatsApp (com código de país)
            </label>
            <Input
              type="tel"
              placeholder="+351912345678"
              value={whatsappNumber}
              onChange={e => setWhatsappNumber(e.target.value)}
              data-testid="whatsapp-number"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Exemplo: +351912345678 (Portugal) ou +34612345678 (Espanha)
            </p>
          </div>
        </div>
      </div>

      {/* Auto cash register close */}
      <div className="bg-white border rounded-xl p-5 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center shrink-0 mt-0.5">
              <Lock className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <p className="font-semibold text-sm">Fecho automático de caixa</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Fecha o caixa automaticamente à hora configurada e envia o relatório para o email e WhatsApp acima.
              </p>
            </div>
          </div>
          <Switch
            checked={autoClose}
            onCheckedChange={setAutoClose}
            data-testid="auto-close-toggle"
          />
        </div>

        {autoClose && (
          <div className="space-y-3 pt-1">
            <div>
              <label className="text-xs font-semibold text-gray-700 block mb-1.5">
                Hora de fecho automático (hora local — Europa/Madrid)
              </label>
              <div className="flex items-center gap-3">
                <Input
                  type="number"
                  min={5}
                  max={23}
                  value={autoCloseHora}
                  onChange={e => setAutoCloseHora(e.target.value)}
                  className="w-24 text-center font-mono text-lg"
                  data-testid="auto-close-hora"
                />
                <span className="text-sm text-muted-foreground font-mono">h</span>
              </div>

              {isMidnightHour ? (
                <div className="flex items-start gap-2 mt-2 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2.5">
                  <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
                  <p className="text-xs text-amber-700">
                    <strong>Hora bloqueada.</strong> Horas entre 0h e 4h são protegidas — o restaurante pode estar a servir a essa hora. Use 5h ou mais tarde.
                  </p>
                </div>
              ) : (
                <p className="text-xs text-muted-foreground mt-1">
                  Recomendado: 5h ou 6h (após o encerramento do serviço noturno).
                  O sistema não fecha se houver pedidos activos nas últimas 2 horas.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
